const MOBILE_TOUCH_MOVE_TOLERANCE = 8
const MOBILE_TOUCH_SELECTION_DISTANCE = 24
const MOBILE_TOUCH_VERTICAL_RATIO = 1.4
const MOBILE_TOUCH_PULL_DISTANCE = 64
const MOBILE_TOUCH_PULL_CANDIDATE_DISTANCE = 24
const MOBILE_TOUCH_PULL_MAX_DURATION = 500
const MOBILE_TOUCH_PULL_MIN_SPEED = 0.32

function getTouchNumber(value, fallback = 0) {
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

export function getMobileTouchGestureMetrics(state, touch, now = Date.now()) {
  const startX = getTouchNumber(state && state.startX)
  const startY = getTouchNumber(state && state.startY)
  const clientX = getTouchNumber(touch && touch.clientX, startX)
  const clientY = getTouchNumber(touch && touch.clientY, startY)
  const deltaX = clientX - startX
  const deltaY = clientY - startY
  const absX = Math.abs(deltaX)
  const absY = Math.abs(deltaY)
  const distance = Math.hypot(deltaX, deltaY)
  const startTime = getTouchNumber(state && state.startTime, now)
  const elapsed = Math.max(0, now - startTime)
  const speed = elapsed > 0 ? distance / elapsed : distance > 0 ? Infinity : 0
  return {
    deltaX,
    deltaY,
    absX,
    absY,
    distance,
    elapsed,
    speed,
    vertical: absY >= absX * MOBILE_TOUCH_VERTICAL_RATIO,
    downward: deltaY > 0
  }
}

export function classifyMobileTouchGesture(state, touch, options = {}) {
  const metrics = getMobileTouchGestureMetrics(state, touch, options.now === undefined ? Date.now() : options.now)
  const moveTolerance = getTouchNumber(options.moveTolerance, MOBILE_TOUCH_MOVE_TOLERANCE)
  const selectionDistance = getTouchNumber(options.selectionDistance, MOBILE_TOUCH_SELECTION_DISTANCE)
  const verticalRatio = getTouchNumber(options.verticalRatio, MOBILE_TOUCH_VERTICAL_RATIO)
  const pullDistance = getTouchNumber(options.pullDistance, MOBILE_TOUCH_PULL_DISTANCE)
  const pullCandidateDistance = getTouchNumber(options.pullCandidateDistance, MOBILE_TOUCH_PULL_CANDIDATE_DISTANCE)
  const pullMaxDuration = getTouchNumber(options.pullMaxDuration, MOBILE_TOUCH_PULL_MAX_DURATION)
  const pullMinSpeed = getTouchNumber(options.pullMinSpeed, MOBILE_TOUCH_PULL_MIN_SPEED)
  const existingType = state && state.gestureType
  if (existingType == 'selection' || (state && state.longPressTriggered)) {
    return 'selection'
  }
  if (metrics.distance <= moveTolerance) {
    return 'pending'
  }
  const vertical = metrics.absY >= metrics.absX * verticalRatio
  const pullRefresh = metrics.downward
    && options.pullEligible !== false
    && vertical
    && metrics.absX < selectionDistance
    && metrics.absY >= Math.max(pullCandidateDistance, pullDistance)
    && metrics.elapsed <= pullMaxDuration
    && metrics.speed >= pullMinSpeed
  if (existingType == 'pull-refresh' || pullRefresh) {
    return 'pull-refresh'
  }
  if (existingType == 'scroll') {
    return 'scroll'
  }
  if (!vertical && metrics.absX >= selectionDistance) {
    return 'selection'
  }
  if (vertical) {
    return 'scroll'
  }
  return 'horizontal-candidate'
}

export const mobileTouchGestureConstants = Object.freeze({
  moveTolerance: MOBILE_TOUCH_MOVE_TOLERANCE,
  selectionDistance: MOBILE_TOUCH_SELECTION_DISTANCE,
  verticalRatio: MOBILE_TOUCH_VERTICAL_RATIO,
  pullDistance: MOBILE_TOUCH_PULL_DISTANCE,
  pullCandidateDistance: MOBILE_TOUCH_PULL_CANDIDATE_DISTANCE,
  pullMaxDuration: MOBILE_TOUCH_PULL_MAX_DURATION,
  pullMinSpeed: MOBILE_TOUCH_PULL_MIN_SPEED
})
